import { SelectedItemsDispatch, SelectedItemsRefContext, SelectedItemInfoRef } from './SelectedItemProvider';

import Id, { Ids } from './IdFactory';
import { useReducer, createContext, useContext, useCallback, useState } from 'react';
import { useDispatch, useStore } from 'react-redux';
import G from './Getters';
import A from './ActionCreators';
import { produce } from 'immer';
import StateWindow from './StateWindow';
import getSelectedItemsMeta from './getSelectedItemsMeta';
import { isUsingWebdriver } from './versionConfig';
import { FigureInteractionEventDispatch } from './Contexts';
import getChangesByCellLocation from './getChangesByCellLocation';

export const FigureModalArgs = createContext();

const insertImageModal = {
  modal:"insertImage",
  cell:[2,1]
}

const editChannels = ({store,figurePanelId,cell}) =>  {
  if( !isUsingWebdriver() ){
    let state = store.getState();
    let cellData = G.getCellsValue(state,{figurePanelId,cells:[cell]})[0];

    return {

      "useCase": "editChannels",
      "modal": "insertImage",
      cellLocation:cell,
      cellData,
      onEvent:event => {



      }
    }
      /*
  "cellData": {
   "valueType": "crop",
   "annotationId": "microAnnot",
   "localTemplateId": "initTemplate",
   "expandable": true,
   "regions": {
    "main": "microAnnot"
   }
  }*/
  }
}

const CONTEXT_MENU_EVENT = "contextMenuEvent";


export default function FigureInteractionProvider({figurePanelId, children}){

  let dispatch = useDispatch();
  const store = useStore();

  const [ modalArgs, setModalArgs ] = useState(
    //editChannels({ store,figurePanelId,cell:[2,1], })
  );

  const setSelectedFigureItems = useContext(SelectedItemsDispatch);

  const selectedFigureItemsRef = useContext(SelectedItemsRefContext);
  const selectedItemInfoRef = useContext(SelectedItemInfoRef);


  const onFigureInteractionEvent = useCallback((e) => {

    const selectedFigureItems = selectedFigureItemsRef.getState();
    const selectedNodes = selectedFigureItems?.expansionNodes;

    let { type, ...args } = e;

    if( e.type === CONTEXT_MENU_EVENT ){
      type = e[CONTEXT_MENU_EVENT].type;
    }

    console.log(e);


    switch(type){

      case "insertGridItem":{

        let { item, direction } = e;

        let actionSuffix = (item==="row" ? "Row" : "Column");
        let action = "insert" + actionSuffix;

        const [row,col] = selectedFigureItems?.cells[0]

        let rowIndex = row;
        let columnIndex = col;

        if( ["right","below"].includes(direction) ){
          rowIndex++;
          columnIndex++;
        }

        dispatch(A[action]({
          figurePanelId,
          rowIndex,
          columnIndex
        }))

        break;
      }
      case "editChannels":{


        let cellLocation = selectedFigureItems.expansionNodes[0].cellLocation;

        let state = store.getState();
        const cellData = G.getCellsValue(state,{figurePanelId,cells:[cellLocation]})[0];

        let { value } = cellData;

        


        //let selectedNode = selectedNodes[0];

        let modalArgs = {
          modal:"insertImage",
          useCase:"insert",
          cellLocation,
          cellData
        }

        setModalArgs(modalArgs)
        break;
      }
      case "setModal":{

        if( !args.modal ){
          throw Error("No modal name given in 'setModal'");
        }
        setModalArgs({
          ...args,
        })

        break;
      }
      case "deleteRows":{
        let selectedCells = selectedFigureItems.cells || [];
        setSelectedFigureItems({});

        dispatch(A.deleteRow(
            {figurePanelId,selectedCells}
        ))
        break;
      }
      case "add":{

        const selectedNodes = selectedFigureItems?.expansionNodes;


        let { type, ...args } = e;


        let eventArgs = args.args;
        let { event } = e;
        if( selectedNodes && selectedNodes.length > 0 ){

          let newNodeIds = [
            ...([window?.__actionArgsOverrides?.nodeId].filter(x => x)), 
            ...Ids(selectedNodes.length),
          ]


          let targetLocations = selectedNodes.map((node,ii) => {
            return {

              [eventArgs.relativeLocation||"inside"]:node.nodeId,
              d:eventArgs.direction,
              nodeId:newNodeIds[ii],
              cellLocation:node.cellLocation,
              newParentNodeId:Id(),
            }
          })



          let insertArgs={
            figurePanelId,
            targetLocations,
            args:{
              ...eventArgs,
              type:eventArgs.type,
            },
            //newParentNodeId:Id()
          }




          dispatch(A.insertNodesInEvaluatedTemplateNodes(insertArgs));



          if( eventArgs.type === "region" ){

            let selectedItemInfo = selectedItemInfoRef.current;
            let { unifiedGroup } = selectedItemInfo;
            let selectionMeta = getSelectedItemsMeta({selectedItems:selectedFigureItems})
            let { cellsReached } = selectionMeta;
            let singleCellSource = cellsReached.length === 1;
            let cellLocation = cellsReached[0];

            let regionId = unifiedGroup?.value?.regionId;

            let shouldPullUpRegionModal = (
              singleCellSource && regionId
            ) 

            if( shouldPullUpRegionModal ){

              let state = store.getState();
              let cellValue = G.getCellsValue(state,{
                cells:[cellLocation],
                figurePanelId
              })[0];
              let { regions } = cellValue;
              let referenceAnnotationId = regions[regionId];

              
              setModalArgs({
                modal:"insertImage",
                useCase:"editChannels",
                cellLocation,
                
                cellData:cellValue,

                targetRegionId:regionId,
              })

            }
          }else{
            setSelectedFigureItems({
              expansionNodes:targetLocations
            })
          }
        }
        break;
      }
      case "setLabel":{

        let { nodeId } = args;

        let cells = [args.cellLocation];
        let propKey = "nodeOverrides."+nodeId+".label";
        dispatch(A.setCellsValueProperties({
          figurePanelId,
          cells,
          properties:{
            [propKey]:args.value
          }
        }))

        break;
      }
      case "setImageResolution":{

        let { imageSetId } = args.args;
        let state = store.getState();
        
        let resolution = G.getImageSetResolution(state,{imageSetId})

        setModalArgs({
          modal:"setImageResolution",
          ...args.args,
          resolution
        })
        break;
      }
      case "addRegionOutline":{
        //take the annotation, the currently selected region
        //and add
        

        let { expansionNodes } = selectedFigureItems;
        let { cellLocation } = expansionNodes[0];



        dispatch(A.addRegionOutlineToNodeExpansionCell({
          figurePanelId,
          cellLocation,
          annotationId:args.annotationId,
          /*
           can easily parameterize this function
           with the nodes we want the outline
           to actually show in certain nodes only
          */

        }));

        setModalArgs();

        break;



      }
      case "drawRegionOutline":{
        return;
      }
      case "specifyExpansionNodeRegion":{



        //let referenceAnnotationId = args.cell.data.value.annotationId;


        let expansionNode = selectedFigureItems.expansionNodes[0];

        

        let selectedItemInfo = selectedItemInfoRef.current;
        let { unifiedGroup } = selectedItemInfo;


        let { cellLocation } = expansionNode;
        const state = store.getState();

        const cellData = G.getCellsValue(state,{figurePanelId,cells:[cellLocation]})[0];

        //HOW TO DECIDE WHICH IMAGE SHOULD BE IN FOCUS
        //ON MODAL LOAD?

        /*
      
          If the choice comes from a unified group with a single image
          it's really quite easy.

          For NOW, we'll just guide them to select an image
          if there's no unified value.

          However, what if we have multiple items selected?

          Ideally, we'd default to a merge..., with the most.
          Otherwise, we should pick the "target node" of the selection
          meaning the node that originally got the click.

          Lastly, if there's no such node, then we need to just 
  
        */


        let defaultImageId = unifiedGroup?.value?.imageId;
        let focusedFsItemList = defaultImageId ? [{type:"imageUploads",_id:defaultImageId}] : [];




          
        setModalArgs({
                modal:"insertImage",
                useCase:"editChannels",
                cellLocation,
                cellData,
                initialState:{
                  focusedFsItemList,
                },
        })

        
        break;
      }

      case "selectCells":{
        let { event, cells, multiselect } = args;
        multiselect = (
          multiselect || (event.ctrlKey || event.shiftKey))

        if(!multiselect){
          setSelectedFigureItems({ cells })
        }else{

          let newCellSet = new Set(
            (selectedFigureItems?.cells||[]).map(x => x.join('-'))
          )


          cells.forEach(cc => {
            let str = cc.join('-');
            if( newCellSet.has(str) ){
              newCellSet.delete(str)
            }else{
              newCellSet.add(str)
            }
          })

          let newCells = Array.from(newCellSet).map(x => x.split('-').map(Number));

          setSelectedFigureItems({ cells:newCells });

        }
        break;
      }
      case "insertionCellDrop":{

        break;
      }
      case "closeModal":{
        setModalArgs();
        break;
      }
      case "click":{


        let { event, ...dataArgs  } = args;
        let { itemType, nodeId, cellLocation } = dataArgs;

        let triggerItem = { triggerNodeId:nodeId, nodeId, cellLocation, cell:cellLocation, figurePanelId };

        let multiselect = (event.ctrlKey || event.shiftKey)


        if( itemType === "expansionNode" ){

          if( false && multiselect ){

            let indexOfSelected = (
              selectedFigureItems.expansionNodes||[]
            ).findIndex(item => {
              return item.nodeId === nodeId && item.cellLocation[0] === cellLocation[0] && item.cellLocation[1] === cellLocation[1] });

            setSelectedFigureItems(produce(selectedFigureItems,draft => {

              if( indexOfSelected === -1 ){
                draft.expansionNodes = [
                  ...(selectedFigureItems.expansionNodes || []),
                  dataArgs
                ]
              }else{
                draft.expansionNodes.splice(indexOfSelected,0);
              }
            })
            )

          }else{

            let state = store.getState();

            let defaultSelection = G.getDefaultSelection(state,{
              ...triggerItem,
              selected:selectedFigureItems.expansionNodes
            })
            let locators = defaultSelection.map(nodeId => 
              ({ cellLocation, nodeId, itemType:"expansionNode"})
            );
            
            let toSelect = {expansionNodes:locators}
            setSelectedFigureItems(toSelect,triggerItem)


          }
        }else if( itemType === "cell" ){

          let { cell } = dataArgs;
          if( multiselect ){

          }else{

            setSelectedFigureItems({
            cells:[args.cell]
          })

          }

        }else{
          throw Error("Unrecognized itemType: '"+itemType+"'");
        }
        break;
      }

      
      case "contextmenu":{
        let { event, ...dataArgs } = args;
        let { itemType } = dataArgs;

        if( itemType === "expansionNode" ){
          setSelectedFigureItems({
            expansionNodes:[dataArgs]
          })
        }
        break;
      }
      case "propertyChange":{

        let args = {
          targetLocations:selectedFigureItems.expansionNodes,
          properties:e.properties
        }

        let byCellLocation = getChangesByCellLocation(args);
        dispatch(A.setCellsValueProperties({
          figurePanelId,
          byCellLocation

        }))
        break;
      }
      default:{
        throw Error(`No registered event type '${type}'.`);
      }
    }
  },[dispatch,figurePanelId,selectedItemInfoRef])




  return (
    <FigureModalArgs.Provider value={modalArgs}>
      <FigureInteractionEventDispatch.Provider value={onFigureInteractionEvent}>
        {children}
        <StateWindow value={selectedFigureItemsRef.current}/>
      </FigureInteractionEventDispatch.Provider>
    </FigureModalArgs.Provider>
  )

}
